import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.758 3.758 2.96 2.96A.563.563 0 0 0 2 3.357v2.58c0 .312.25.563.563.563h2.58a.563.563 0 0 0 .398-.96l-.721-.723a4.501 4.501 0 1 1 .61 6.877.752.752 0 0 0-.861 1.23 6 6 0 1 0-.81-9.166M8 5a.56.56 0 0 0-.562.563V8c0 .15.058.293.164.398l1.687 1.688a.562.562 0 0 0 .795-.794L8.56 7.767V5.563A.56.56 0 0 0 7.998 5z"
    }, null, -1)
  ]))]))
}
export default { render: render }